import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import GTM from "../../analytics/GTM";
import ThumbNailCarousel from "../PdpComponents/ThumbNailCarousel";
import MainCarousel from "../PdpComponents/MainCarousel";
import ProductRightPanel from "../ProductList/ProductRightPanel";
import PdpFitGuide from "../PdpComponents/PdpFitGuide";
import PdpIcons from "../PdpComponents/PdpIcons";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
  Modal,
  Ripple,
} from "arv-reactcomponents";
import { redirect, isDesktop } from "../../utils";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import PincodeBlock from "../PdpComponents/PincodeBlock";
import SizeBlock from "../ProductList/SizeBlock";

@inject("ProductStore", "MybagStore", "LoginStore")
@observer
class pdpDetailsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainImage: null,
      selectedSku: null,
      showSizePrompt: false,
      imageIndex: 0,
      fitGuideModal: false,
      preventfix: false,
    };
    this.currentStyleId = null;
    this.addedToBag = false;
    this.setMainImage = this.setMainImage.bind(this);
    this.selectSku = this.selectSku.bind(this);
    this.addToBag = this.addToBag.bind(this);
    this.closeFitGuideModal = this.closeFitGuideModal.bind(this);
    this.fitGuideModal = this.fitGuideModal.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.selectSkuAndAddToBag = this.selectSkuAndAddToBag.bind(this);
    this.setImageIndex = this.setImageIndex.bind(this);
    this.setStyle = this.setStyle.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentStyleId !== this.currentStyleId) {
      this.currentStyleId = nextProps.currentStyleId;
      this.addedToBag = false;
      this.setState({ selectedSku: null, imageIndex: 0 });
    }
    if (
      nextProps.ProductLoader === false &&
      this.props.ProductLoader === true
    ) {
      this.setState({ mainImage: null });
    }
  }
  @computed
  get cartItemSkus() {
    return (
      (this.props.MybagStore.cartItems &&
        Object.keys(this.props.MybagStore.cartItems)) ||
      []
    );
  }

  get addToBagCurrentState() {
    return this.cartItemSkus.includes(this.selectedSkuId) && this.addedToBag
      ? "CHECKOUT"
      : "ADD TO BAG";
  }

  get isLoader() {
    return this.props.ProductLoader ? "nwc-hide" : "";
  }
  get selectedSkuObj() {
    const { selectedSku } = this.props.ProductStore.pdpDetails;
    return this.state.selectedSku || selectedSku;
  }
  get selectedSkuId() {
    return this.selectedSkuObj && this.selectedSkuObj.skuId;
  }
  setMainImage(mainImage) {
    this.setState({ mainImage });
  }
  setImageIndex(imageIndex) {
    this.setState({ imageIndex });
  }

  setStyle(e, styleId, mainImage) {
    Analytics.trackEvent({
      action: Event.action.COLOR_CHANGE,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
    this.setState({ selectedSku: null, imageIndex: 0, mainImage });
  }
  addToBag(event, init) {
    if (event) {
      event.preventDefault();
    }
    if (this.addToBagCurrentState === "CHECKOUT") {
      if (this.props.LoginStore.isUserLoggedIn) {
        redirect("checkout");
      } else {
        window.goToRouteOnLogin = "checkout";
        this.props.LoginStore.setloginModal(true);
      }

      Analytics.trackEvent({
        action: Event.action.CHECKOUT_CLICK,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });

      return null;
    }
    const {
      brandName,
      image,
      name,
      quantity,
      url,
      promotions,
      colorDetails,
      styleId,
    } = this.props.ProductStore.pdpDetails;
    const { secondaryColor, primaryColor } = colorDetails;
    const selectedSku = init || this.selectedSkuObj;
    const product = {
      skuId: selectedSku.skuId,
      brandName,
      image: image.thumbnail || null,
      mrp: selectedSku.mrp,
      size: selectedSku.size,
      name,
      price: selectedSku.price,
      grossSP: selectedSku.price,
      qty: (quantity && quantity.default) || 1,
      url,
      sellableQty: selectedSku.sellableQuantity,
      styleId,
      discountInPercentage: selectedSku.discountInPercentage || 0,
      promotions,
      color: secondaryColor || primaryColor,
    };
    if (selectedSku && selectedSku.skuId) {
      this.props.MybagStore.addToBag(product);
      this.addedToBag = true;
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SUCCESS,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
      GTM.pushWithEvent(
        {
          Id: product.skuId,
          brand: product.brandName,
          desc: product.name,
          mrp: product.mrp,
          dscnt: product.discountInPercentage,
          price: product.price,
          size: product.size,
          Qty: product.qty,
        },
        "add_to_cart",
      );
    } else {
      this.setState({ showSizePrompt: true });
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SIZE_PROMT,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
    }
    return null;
  }
  closePrompt(postAddToBag) {
    if (this.state.fitGuideModal) {
      return null;
    }
    this.setState({ showSizePrompt: false });
    if (postAddToBag !== true) {
      Analytics.trackEvent({
        action: Event.action.ADD_TO_BAG_SIZE_PROMPT_CLOSE,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
    }
    return null;
  }
  selectSku(sku) {
    this.setState({
      selectedSku: sku,
    });
    this.addedToBag = false;
    Analytics.trackEvent({
      action: Event.action.SIZE_CHANGE,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      label: sku.skuId,
    });
  }
  fitGuideModal(flag) {
    Analytics.trackEvent({
      action: Event.action.FIT_GUIDE_CLICK,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
    this.setState({ fitGuideModal: true, preventfix: !!flag });
  }

  closeFitGuideModal() {
    this.setState({ fitGuideModal: false, preventfix: false });
  }
  selectSkuAndAddToBag(sku) {
    Analytics.trackEvent({
      action: Event.action.ADD_TO_BAG_SIZE_PROMPT_SELECTED,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
    this.selectSku(sku);
    this.addToBag(null, sku);
    this.closePrompt(true);
  }

  render() {
    const { mainImage, imageIndex, fitGuideModal, preventfix } = this.state;
    const { pdpDetails } = this.props.ProductStore;
    const {
      images,
      brandName,
      name,
      sizeChartId,
      skus,
      inStock,
      styleId,
    } = pdpDetails;
    const pdpMainThumbImage =
      (images && images[0] && images[0].thumbnail) || "";
    const { ProductLoader, setWishList, wishListData } = this.props;
    const selectedSku = this.selectedSkuObj;
    const skuId = (selectedSku && selectedSku.skuId) || "";
    return (
      <div>
        <GridContainer className="nw-pdp">
          <GridRow>
            <GridColumn className="nwc-grid-col-md nw-pdp-left">
              <GridRow>
                <GridColumn className="nwc-grid-col-sm nw-pdp-vertical">
                  <ThumbNailCarousel
                    list={images}
                    setImageIndex={this.setImageIndex}
                    ProductLoader={ProductLoader}
                    imageIndex={imageIndex}
                    index={imageIndex}
                  />
                </GridColumn>
                <GridColumn className="nwc-grid-col-sm nw-pdp-img-carousel">
                  <div className="nw-pdp-image">
                    <MainCarousel
                      list={images}
                      setImageIndex={this.setImageIndex}
                      ProductLoader={ProductLoader}
                      imageIndex={imageIndex}
                      index={imageIndex}
                      mainImage={mainImage}
                    />
                  </div>
                </GridColumn>
              </GridRow>
            </GridColumn>
            <GridColumn className="nwc-grid-col-md nw-pdppage-right-panel">
              <ProductRightPanel
                className="nw-pdppage-right-wrapper"
                pdpMainThumbImage={pdpMainThumbImage}
                setMainImage={this.setMainImage}
                addToBag={this.addToBag}
                selectSku={this.selectSku}
                ProductLoader={ProductLoader}
                selectedSku={selectedSku}
                buttonText={this.addToBagCurrentState}
                pdpDetails={pdpDetails}
                setStyle={this.setStyle}
                skuId={skuId}
              />
              <PdpIcons
                ProductLoader={ProductLoader}
                sizeChartId={sizeChartId}
                styleId={styleId}
                brandName={brandName}
                name={name}
                images={images}
                inStock={inStock}
                setWishList={setWishList}
                wishListData={wishListData}
                fitGuideModal={this.fitGuideModal}
              />
              <PincodeBlock
                className={`nw-pdp-pincodeblock ${this.isLoader}`}
                selectedSkuId={skuId}
                getShippingDetails={this.props.ProductStore.getShippingDetails}
                styleId={styleId}
                inStock={inStock}
              />
              <div className="nw-pdp-addtobag-sticky">
                <Ripple className="nwc-ripple-light">
                  <Button
                    disabled={!inStock}
                    className="nw-pdp-addtobag-mobile nwc-btn-primary"
                    onClick={this.addToBag}
                  >
                    {this.addToBagCurrentState}
                  </Button>
                </Ripple>
              </div>
            </GridColumn>
          </GridRow>
        </GridContainer>
        <Modal
          isOpen={this.state.showSizePrompt}
          onClose={this.closePrompt}
          className="nw-pdp-sizeprompt"
        >
          <div className="nw-pdp-sizeprompt">
            <div className="nw-pdp-sizeprompttop">
              <p className="nw-pdp-sizeprompttext">
                {isDesktop ? "Select size to add to bag:" : "Which Size?"}
              </p>
              {sizeChartId && (
                <Button
                  className="nw-pdp-sizepromptsizechart"
                  onClick={() => this.fitGuideModal(true)}
                >
                  <i className="icomoon-ruler-black nw-sizeprompt-rulericon" />
                  Fit Guide
                </Button>
              )}
            </div>
            <div className="nw-pdp-sizepromptlist">
              <SizeBlock
                selectedSkuId={skuId}
                selectSku={this.selectSkuAndAddToBag}
                skus={skus}
                ProductLoader={ProductLoader}
              />
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={fitGuideModal}
          preventfix={preventfix}
          onClose={this.closeFitGuideModal}
        >
          <PdpFitGuide
            brandName={brandName}
            productTitle={name}
            sizeChartId={sizeChartId}
          />
        </Modal>
      </div>
    );
  }
}

pdpDetailsBlock.wrappedComponent.defaultProps = {
  wishListData: [],
};

pdpDetailsBlock.wrappedComponent.propTypes = {
  currentStyleId: PropTypes.string.isRequired,
  ProductLoader: PropTypes.bool.isRequired,
  wishListData: PropTypes.object, // eslint-disable-line
  setWishList: PropTypes.func.isRequired,
  LoginStore: PropTypes.shape({
    setloginModal: PropTypes.func.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    getShippingDetails: PropTypes.func.isRequired,
    pdpDetails: PropTypes.shape({
      skus: PropTypes.arrayOf(PropTypes.shape({})),
      colors: PropTypes.shape([]),
      inStock: PropTypes.bool,
      discountRange: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
      }),
      mrpRange: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
      }),
      sellingPriceRange: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
      }),
      isNew: PropTypes.bool,
      promotions: PropTypes.arrayOf(PropTypes.object),
      brandName: PropTypes.string,
      name: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.shape({})),
      quantity: PropTypes.shape({
        default: PropTypes.number,
        maximum: PropTypes.number,
      }),
      url: PropTypes.string,
      colorDetails: PropTypes.shape({}),
      image: PropTypes.shape({
        thumbnail: PropTypes.string,
      }),
      brandText: PropTypes.string,
      styleId: PropTypes.string,
      sizeChartId: PropTypes.string,
      selectedSku: PropTypes.shape({}),
    }).isRequired,
  }).isRequired,
  MybagStore: PropTypes.shape({
    addToBag: PropTypes.func.isRequired,
    cartItems: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default pdpDetailsBlock;



// WEBPACK FOOTER //
// ./src/component/PdpDetailsBlock/index.js